<template>
  <v-form>
    <v-container class="text-center">
      <v-row>
        <v-col cols="12">
          <div class="display-1">
            Complete your profile
          </div>
          <div class="subtitle-1">
            Please review and update your profile information:
          </div>
        </v-col>
      </v-row>

      <v-row justify="center">
        <v-col
          cols="3"
          class="mx-2"
        >
          <v-text-field
            v-model="profile.firstName"
            color="white"
            dark
            label="First name"
          />
        </v-col>
        <v-col
          cols="3"
          class="mx-2"
        >
          <v-text-field
            v-model="profile.lastName"
            color="white"
            dark
            label="Last name"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col class="x12">
          <div class="subtitle-1">
            When's your birthday?
          </div>
          <div class="caption">
            We use this to show you age-specific reports and research insights.<br>
            When sharing, other users will see this information only as an age range
            (e.g. 30-40).
          </div>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col cols="3">
          <v-menu
            ref="birthDateMenu"
            v-model="birthDateMenuShown"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <template #activator="{ on }">
              <v-text-field
                v-model="profile.birthDate"
                color="white"
                dark
                style="text-align: center;"
                label="Birthday date"
                prepend-icon="mdi-calendar"
                readonly
                v-on="on"
              />
            </template>
            <v-date-picker
              ref="birthDatePicker"
              :value="profile.birthDate"
              :max="new Date().toISOString().substr(0, 10)"
              min="1900-01-01"
              @change="birthDateSelected"
            />
          </v-menu>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <div class="subtitle-1">
            What's your biological sex?
          </div>
          <div class="caption">
            We use this to show you gender-specific reports and research insights.
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-radio-group
            v-model="profile.sex"
            color="white"
            dark
            row
            class="justify-center"
            @change="dirty = true"
          >
            <v-radio
              label="Female"
              value="F"
            />
            <v-radio
              label="Male"
              value="M"
            />
          </v-radio-group>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-btn
            @click="submit"
          >
            Save
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'EditProfileForm',
  props: {
    firstName: { type: String, required: true },
    lastName: { type: String, required: true },
    birthDate: { type: String, required: true },
    sex: { type: String, required: true },
  },
  data() {
    return {
      profile: {
        firstName: this.firstName,
        lastName: this.lastName,
        birthDate: this.birthDate,
        sex: this.sex,
      },
      birthDateMenuShown: false,
    };
  },
  watch: {
    async birthDateMenuShown() {
      if (this.birthDateMenuShown) {
        await this.$nextTick();
        this.$refs.birthDatePicker.activePicker = 'YEAR';
      }
    },
  },
  methods: {
    birthDateSelected(date) {
      this.$refs.birthDateMenu.save(date);
      this.profile.birthDate = date;
    },
    async submit() {
      await this.setProfileData(this.profile);
      this.$emit('submit');
    },
    ...mapActions('profile', ['setProfileData']),
  },
};
</script>
